import * as c from "react";
import { p as r } from "./index-efd35e77.js";
import { C as H, T as K } from "./TransitionGroup-34043d49.js";
import { n as s } from "./noop-d627517c.js";
import { c as S, v as L } from "./package-metadata-a152adb8.js";
var M = function(n) {
  if (!n || !n.ownerDocument.defaultView)
    return 0;
  var a = n.ownerDocument.defaultView, e = a.getComputedStyle(n), t = parseFloat(e.marginTop), i = parseFloat(e.marginBottom);
  return n.offsetHeight + t + i;
}, U = function(n) {
  if (!n || !n.ownerDocument.defaultView)
    return 0;
  var a = n.ownerDocument.defaultView, e = a.getComputedStyle(n), t = parseFloat(e.marginLeft), i = parseFloat(e.marginRight);
  return n.offsetWidth + t + i;
}, W = {
  "animation-container": "k-animation-container",
  "animation-container-relative": "k-animation-container-relative",
  "animation-container-fixed": "k-animation-container-fixed",
  "push-right-enter": "k-push-right-enter",
  "push-right-appear": "k-push-right-appear",
  "push-right-enter-active": "k-push-right-enter-active",
  "push-right-appear-active": "k-push-right-appear-active",
  "push-right-exit": "k-push-right-exit",
  "push-right-exit-active": "k-push-right-exit-active",
  "push-left-enter": "k-push-left-enter",
  "push-left-appear": "k-push-left-appear",
  "push-left-enter-active": "k-push-left-enter-active",
  "push-left-appear-active": "k-push-left-appear-active",
  "push-left-exit": "k-push-left-exit",
  "push-left-exit-active": "k-push-left-exit-active",
  "push-down-enter": "k-push-down-enter",
  "push-down-appear": "k-push-down-appear",
  "push-down-enter-active": "k-push-down-enter-active",
  "push-down-appear-active": "k-push-down-appear-active",
  "push-down-exit": "k-push-down-exit",
  "push-down-exit-active": "k-push-down-exit-active",
  "push-up-enter": "k-push-up-enter",
  "push-up-appear": "k-push-up-appear",
  "push-up-enter-active": "k-push-up-enter-active",
  "push-up-appear-active": "k-push-up-appear-active",
  "push-up-exit": "k-push-up-exit",
  "push-up-exit-active": "k-push-up-exit-active",
  expand: "k-expand",
  "expand-vertical-enter": "k-expand-vertical-enter",
  "expand-vertical-appear": "k-expand-vertical-appear",
  "expand-vertical-enter-active": "k-expand-vertical-enter-active",
  "expand-vertical-appear-active": "k-expand-vertical-appear-active",
  "expand-vertical-exit": "k-expand-vertical-exit",
  "expand-vertical-exit-active": "k-expand-vertical-exit-active",
  "expand-horizontal-enter": "k-expand-horizontal-enter",
  "expand-horizontal-appear": "k-expand-horizontal-appear",
  "expand-horizontal-enter-active": "k-expand-horizontal-enter-active",
  "expand-horizontal-appear-active": "k-expand-horizontal-appear-active",
  "expand-horizontal-exit": "k-expand-horizontal-exit",
  "expand-horizontal-exit-active": "k-expand-horizontal-exit-active",
  "child-animation-container": "k-child-animation-container",
  "fade-enter": "k-fade-enter",
  "fade-appear": "k-fade-appear",
  "fade-enter-active": "k-fade-enter-active",
  "fade-appear-active": "k-fade-appear-active",
  "fade-exit": "k-fade-exit",
  "fade-exit-active": "k-fade-exit-active",
  "zoom-in-enter": "k-zoom-in-enter",
  "zoom-in-appear": "k-zoom-in-appear",
  "zoom-in-enter-active": "k-zoom-in-enter-active",
  "zoom-in-appear-active": "k-zoom-in-appear-active",
  "zoom-in-exit": "k-zoom-in-exit",
  "zoom-in-exit-active": "k-zoom-in-exit-active",
  "zoom-out-enter": "k-zoom-out-enter",
  "zoom-out-appear": "k-zoom-out-appear",
  "zoom-out-enter-active": "k-zoom-out-enter-active",
  "zoom-out-appear-active": "k-zoom-out-appear-active",
  "zoom-out-exit": "k-zoom-out-exit",
  "zoom-out-exit-active": "k-zoom-out-exit-active",
  "slide-in-appear": "k-slide-in-appear",
  centered: "k-centered",
  "slide-in-appear-active": "k-slide-in-appear-active",
  "slide-down-enter": "k-slide-down-enter",
  "slide-down-appear": "k-slide-down-appear",
  "slide-down-enter-active": "k-slide-down-enter-active",
  "slide-down-appear-active": "k-slide-down-appear-active",
  "slide-down-exit": "k-slide-down-exit",
  "slide-down-exit-active": "k-slide-down-exit-active",
  "slide-up-enter": "k-slide-up-enter",
  "slide-up-appear": "k-slide-up-appear",
  "slide-up-enter-active": "k-slide-up-enter-active",
  "slide-up-appear-active": "k-slide-up-appear-active",
  "slide-up-exit": "k-slide-up-exit",
  "slide-up-exit-active": "k-slide-up-exit-active",
  "slide-right-enter": "k-slide-right-enter",
  "slide-right-appear": "k-slide-right-appear",
  "slide-right-enter-active": "k-slide-right-enter-active",
  "slide-right-appear-active": "k-slide-right-appear-active",
  "slide-right-exit": "k-slide-right-exit",
  "slide-right-exit-active": "k-slide-right-exit-active",
  "slide-left-enter": "k-slide-left-enter",
  "slide-left-appear": "k-slide-left-appear",
  "slide-left-enter-active": "k-slide-left-enter-active",
  "slide-left-appear-active": "k-slide-left-appear-active",
  "slide-left-exit": "k-slide-left-exit",
  "slide-left-exit-active": "k-slide-left-exit-active",
  "reveal-vertical-enter": "k-reveal-vertical-enter",
  "reveal-vertical-appear": "k-reveal-vertical-appear",
  "reveal-vertical-enter-active": "k-reveal-vertical-enter-active",
  "reveal-vertical-appear-active": "k-reveal-vertical-appear-active",
  "reveal-vertical-exit": "k-reveal-vertical-exit",
  "reveal-vertical-exit-active": "k-reveal-vertical-exit-active",
  "reveal-horizontal-enter": "k-reveal-horizontal-enter",
  "reveal-horizontal-appear": "k-reveal-horizontal-appear",
  "reveal-horizontal-enter-active": "k-reveal-horizontal-enter-active",
  "reveal-horizontal-appear-active": "k-reveal-horizontal-appear-active",
  "reveal-horizontal-exit": "k-reveal-horizontal-exit",
  "reveal-horizontal-exit-active": "k-reveal-horizontal-exit-active"
}, B = {
  outerHeight: M,
  outerWidth: U,
  styles: W
};
const C = B;
var G = globalThis && globalThis.__extends || function() {
  var n = function(a, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, i) {
      t.__proto__ = i;
    } || function(t, i) {
      for (var l in i)
        Object.prototype.hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }, n(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), p = globalThis && globalThis.__assign || function() {
  return p = Object.assign || function(n) {
    for (var a, e = 1, t = arguments.length; e < t; e++) {
      a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }
    return n;
  }, p.apply(this, arguments);
}, J = globalThis && globalThis.__rest || function(n, a) {
  var e = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && a.indexOf(t) < 0 && (e[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, t = Object.getOwnPropertySymbols(n); i < t.length; i++)
      a.indexOf(t[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[i]) && (e[t[i]] = n[t[i]]);
  return e;
}, u = C.styles, Q = (
  /** @class */
  function(n) {
    G(a, n);
    function a() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.elementRef = c.createRef(), e;
    }
    return Object.defineProperty(a.prototype, "element", {
      /**
       * The element that is being animated.
       */
      get: function() {
        return this.elementRef.current;
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var e = this, t = this.props, i = t.children, l = t.style, x = t.appear, g = t.enter, y = t.exit, o = t.transitionName, d = t.transitionEnterDuration, v = t.transitionExitDuration, k = t.className, m = t.onEnter, h = t.onEntering, E = t.onEntered, w = t.onExit, O = t.onExiting, _ = t.onExited, z = t.onAfterExited, T = t.mountOnEnter, N = t.unmountOnExit, j = t.animationEnteringStyle, D = t.animationEnteredStyle, R = t.animationExitingStyle, P = t.animationExitedStyle, A = J(t, ["children", "style", "appear", "enter", "exit", "transitionName", "transitionEnterDuration", "transitionExitDuration", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "onAfterExited", "mountOnEnter", "unmountOnExit", "animationEnteringStyle", "animationEnteredStyle", "animationExitingStyle", "animationExitedStyle"]), q = S(k, u["child-animation-container"]), F = p({ transitionDelay: "0ms" }, l), $ = {
        entering: p({ transitionDuration: "".concat(d, "ms") }, j),
        entered: p({}, D),
        exiting: p({ transitionDuration: "".concat(v, "ms") }, R),
        exited: p({}, P)
      }, I = {
        in: this.props.in,
        appear: x,
        enter: g,
        exit: y,
        mountOnEnter: T,
        unmountOnExit: N,
        timeout: {
          enter: d,
          exit: v
        },
        onEnter: function() {
          m && m.call(void 0, { animatedElement: e.element, target: e });
        },
        onEntering: function() {
          h && h.call(void 0, { animatedElement: e.element, target: e });
        },
        onEntered: function() {
          E && E.call(void 0, { animatedElement: e.element, target: e });
        },
        onExit: function() {
          w && w.call(void 0, { animatedElement: e.element, target: e });
        },
        onExiting: function() {
          O && O.call(void 0, { animatedElement: e.element, target: e });
        },
        onExited: function() {
          z && z.call(void 0, { animatedElement: e.element, target: e }), _ && _.call(void 0, { animatedElement: e.element, target: e });
        },
        classNames: {
          appear: u["".concat(o, "-appear")] || "".concat(o, "-appear"),
          appearActive: u["".concat(o, "-appear-active")] || "".concat(o, "-appear-active"),
          enter: u["".concat(o, "-enter")] || "".concat(o, "-enter"),
          enterActive: u["".concat(o, "-enter-active")] || "".concat(o, "-enter-active"),
          exit: u["".concat(o, "-exit")] || "".concat(o, "-exit"),
          exitActive: u["".concat(o, "-exit-active")] || "".concat(o, "-exit-active")
        }
      };
      return c.createElement(H, p({}, I, A, { nodeRef: this.elementRef }), function(V) {
        return c.createElement("div", { style: p(p({}, F), $[V]), className: q, ref: e.elementRef }, i);
      });
    }, a.propTypes = {
      in: r.bool,
      children: r.oneOfType([
        r.arrayOf(r.node),
        r.node
      ]),
      transitionName: r.string.isRequired,
      className: r.string,
      appear: r.bool,
      enter: r.bool,
      exit: r.bool,
      transitionEnterDuration: r.number.isRequired,
      transitionExitDuration: r.number.isRequired,
      mountOnEnter: r.bool,
      unmountOnExit: r.bool,
      animationEnteringStyle: r.object,
      animationEnteredStyle: r.object,
      animationExitingStyle: r.object,
      animationExitedStyle: r.object
    }, a.defaultProps = {
      mountOnEnter: !0,
      unmountOnExit: !1,
      onEnter: s,
      onEntering: s,
      onEntered: s,
      onExit: s,
      onExiting: s,
      onExited: s,
      onAfterExited: s,
      animationEnteringStyle: {},
      animationEnteredStyle: {},
      animationExitingStyle: {},
      animationExitedStyle: {}
    }, a;
  }(c.Component)
), X = {
  name: "@progress/kendo-react-animation",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686225019,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Y = globalThis && globalThis.__extends || function() {
  var n = function(a, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, i) {
      t.__proto__ = i;
    } || function(t, i) {
      for (var l in i)
        Object.prototype.hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }, n(a, e);
  };
  return function(a, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(a, e);
    function t() {
      this.constructor = a;
    }
    a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), f = globalThis && globalThis.__assign || function() {
  return f = Object.assign || function(n) {
    for (var a, e = 1, t = arguments.length; e < t; e++) {
      a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }
    return n;
  }, f.apply(this, arguments);
}, Z = globalThis && globalThis.__rest || function(n, a) {
  var e = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && a.indexOf(t) < 0 && (e[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, t = Object.getOwnPropertySymbols(n); i < t.length; i++)
      a.indexOf(t[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[i]) && (e[t[i]] = n[t[i]]);
  return e;
}, b = C.styles, ie = (
  /** @class */
  function(n) {
    Y(a, n);
    function a(e) {
      var t = n.call(this, e) || this;
      return L(X), t;
    }
    return a.prototype.render = function() {
      var e = this.props, t = e.id, i = e.style, l = e.children, x = e.component, g = e.className, y = e.childFactory;
      e.stackChildren;
      var o = e.componentChildStyle, d = e.componentChildClassName, v = Z(e, ["id", "style", "children", "component", "className", "childFactory", "stackChildren", "componentChildStyle", "componentChildClassName"]), k = {
        id: t,
        style: i,
        component: x,
        childFactory: y,
        className: S(b["animation-container"], b["animation-container-relative"], g)
      }, m = c.Children.map(l || null, function(h) {
        return c.createElement(Q, f({}, v, { style: o, className: d }), h);
      });
      return c.createElement(K, f({}, k), m);
    }, a.propTypes = {
      children: r.oneOfType([
        r.arrayOf(r.node),
        r.node
      ]),
      childFactory: r.any,
      className: r.string,
      component: r.string,
      id: r.string,
      style: r.any,
      transitionName: r.string.isRequired,
      appear: r.bool.isRequired,
      enter: r.bool.isRequired,
      exit: r.bool.isRequired,
      transitionEnterDuration: r.number.isRequired,
      transitionExitDuration: r.number.isRequired
    }, a.defaultProps = {
      component: "div"
    }, a;
  }(c.Component)
);
export {
  ie as A
};
